<app-loader [isLoader]="loading"></app-loader>
<div class="modal-overlay" (click)="onBackdropClick($event)" [ngClass]="{'show': isOpen}">
  <div class="modal-container" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <h2>{{editMode ? 'Update User' : 'Create User'}}</h2>
      <button class="close-btn" (click)="onCancel()">
        <span>&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <form [formGroup]="createUserForm" (ngSubmit)="onSubmit()">

        <div class="profile-section">
          <div class="profile-picture-container">
            <div class="profile-picture">
              @if(profileImageUrl){
                <img [src]="profileImageUrl" alt="Profile" referrerpolicy="no-referrer" (error)="onImageError()" />
              }@else {
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              }
            </div>
            <div class="profile-info">
              <h3>Profile Picture</h3>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group" [ngClass]="{'disabled': editMode}">
            <label for="email">Email Address *</label>
            <input type="email" id="email" formControlName="email" placeholder="user@example.com" class="form-control">
            @if(createUserForm.get('email')?.invalid && createUserForm.get('email')?.touched){
            <div class="error-message">
              Please enter a valid email address
            </div>
            }

          </div>

          <div class="form-group">
            <label for="role">User Role *</label>
            <select id="role" formControlName="role" class="form-control" (change)="onRoleChange($event)">
              <option value="">Select a role</option>
              @for(role of roles;track $index){
              <option [value]="role">
                {{ role | titlecase }}
              </option>
              }

            </select>
            @if(createUserForm.get('role')?.invalid && createUserForm.get('role')?.touched){
            <div class="error-message">
              Please select a role
            </div>
            }
          </div>
        </div>


        @if(editMode){
        <div class="form-group" [ngClass]="{'disabled': editMode}">
          <label for="name">Full Name</label>
          <input type="text" id="name" formControlName="name" placeholder="Will be set after user creation"
            class="form-control">
        </div>
        }


        <div class="permissions-section">
          <label class="permissions-label">Permissions</label>
          <div class="permissions-grid" [ngClass]="{'disabled': disablePermissions}">
            @for(permission of permissions;track $index){
            <div class="permission-item">
              <label class="permission-checkbox">
                <input type="checkbox" [checked]="isPermissionSelected(permission.id)"
                  (change)="onPermissionChange(permission.id, $event)" class="checkbox-input">
                <span class="checkmark"></span>
                <span class="permission-label">{{ permission.name | titlecase }}</span>
              </label>
            </div>
            }
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        Cancel
      </button>
      @if(editMode){
      <button type="button" class="btn btn-primary" (click)="updateUser()"
        [disabled]="loading || createUserForm.invalid">
        <span>Update User</span>
      </button>
      }
      @else{
      <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="loading || createUserForm.invalid">
        <span>Create User</span>
      </button>
      }
    </div>
  </div>
</div>